import { qs } from "@fluorescent/dom";

import { section } from "@/neon";
import mobileCarousel from "@/lib/mobile-carousel";

const sel = {
  recommendations: "[data-recommendations]",
  slider: "[data-slider]",
};

section("recommended-products", {
  onLoad() {
    const { limit, productId: id, sectionId } = this.container.dataset;

    const content = qs(sel.recommendations, this.container);
    if (!content) return;

    const requestUrl = `${window.theme.routes.productRecommendations}?section_id=${sectionId}&limit=${limit}&product_id=${id}`;

    const request = new XMLHttpRequest();
    request.open("GET", requestUrl, true);

    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        let container = document.createElement("div");
        container.innerHTML = request.response;

        // Check if the response includes a product item
        // and if it doesn't remove the entire section
        const item = qs(".product-item", container);
        if (!item) {
          this.container.parentNode.removeChild(this.container);
          return;
        }

        content.innerHTML = qs(sel.recommendations, container).innerHTML;

        const carousel = qs(sel.slider, content);

        if (carousel) {
          this.mobileCarousel = mobileCarousel(carousel);
        }
      } else {
        // If request returns any errors remove the section markup
        this.container.parentNode.removeChild(this.container);
      }
    };
    request.send();
  },

  onUnload() {
    this.mobileCarousel && this.mobileCarousel.destroy();
  },
});
